<template>
  <div class="album">
    <!-- {{photos}} -->
    <div class="inner-header">
      <h2 class="page-header">{{ category.name }}</h2>
    </div>
    <div class="container">
      <div class="pages" v-if="pages && pages > 1">
        <b-button
          v-show="showPager('-')"
          @click="getPage(Number(currentPage) - 1)"
          variant="light"
        >
          &laquo;
        </b-button>
        <b-button
          v-for="page in displayPages"
          @click="getPage(page)"
          :class="{ active: page == currentPage }"
          >{{ page }}</b-button
        >
        <b-button
          v-show="showPager('+')"
          variant="light"
          @click="getPage(Number(currentPage) + 1)"
        >
          &raquo;
        </b-button>
      </div>
      <div class="photogallery" v-if="photos && photos.length > 0">
        <masonry :cols="4" :gutter="20">
          <div v-for="photo in photos" class="photo">
            <img
              :src="imagePath + 'resize_600/' + photo.file"
              @click="viewPhoto(photo)"
            />
          </div>
        </masonry>
      </div>
      <div class="pages" v-if="pages && pages > 1">
        <b-button
          v-show="showPager('-')"
          @click="getPage(Number(currentPage) - 1)"
          variant="light"
        >
          &laquo;
        </b-button>
        <b-button
          v-for="page in displayPages"
          @click="getPage(page)"
          :class="{ active: page == currentPage }"
          >{{ page }}</b-button
        >
        <b-button
          v-show="showPager('+')"
          variant="light"
          @click="getPage(Number(currentPage) + 1)"
        >
          &raquo;
        </b-button>
      </div>
      <!-- <div v-else>album Not Found</div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
// import LightBox from 'vue-image-lightbox'
const ListingsRepository = RepositoryFactory.get("listings");
const CategoriesRepository = RepositoryFactory.get("categories");

export default {
  components: {
    LightBox: () => import("vue-image-lightbox")
  },
  data() {
    return {
      slug: this.$route.params.slug,
      photos: "",
      pages: "",
      limit: 100,
      locCategories: [],
      albumCategories: [],
      displayPages: [],
      pages: this.$route.params.pages,
      currentPage: this.$route.params.page,
      showLightBox: true,
      showThumbs: true,
      category: {}
    };
  },
  metaInfo() {
    // return {
    // let dealTitle = this.deal.title
    // let dealDescription = this.deal.description

    return {
      title: "Sugar Weddings & Parties | Gallery",
      meta: [
        {
          name: "description",
          content:
            " Nigerian wedding pictures, nigerian event pictures, event vendor photos, real wedding pictures"
        }
      ]
    };
  },
  methods: {
    getPage(page) {
      // console.log(page)
      this.currentPage = page;
      // this.getListings(page, 12)
      this.fetchPhotosByTag(this.slug, this.currentPage, this.limit);
      var url = window.location.pathname;
      var currentUrl = url.split("/");
      var cLength = currentUrl.length - 1;
      // console.log(cLength)
      currentUrl[cLength] = page;
      var newUrl = currentUrl.join("/");
      console.log("new url", newUrl);
      history.pushState(null, "", newUrl);
      // console.log(currentUrl)

      this.displaySubPages();

      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    showPager(dir) {
      if (dir == "+") {
        if (Number(this.currentPage) + 2 < this.pages && this.pages > 8) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.displayPages[0] > 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    displaySubPages() {
      this.displayPages = [];
      console.log("pages", this.pages);
      for (var j = 1; j <= this.pages; j++) {
        this.displayPages.push(j);
      }
      // console.log(this.displayPages)

      if (this.pages > 8) {
        this.displayPages = [];
        this.currentPage = Number(this.currentPage);
        let start = this.currentPage - 2;
        let end = this.currentPage + 3;

        if (this.currentPage == 1 || this.currentPage == 2) {
          end = this.currentPage + 6 - this.currentPage;
        }

        if (this.currentPage == this.pages) {
          start = this.currentPage - 4;
        }

        if (this.currentPage == this.pages - 1) {
          start = this.currentPage - 3;
        }

        for (var i = start; i < end; i++) {
          if (i > 0 && i <= this.pages) {
            this.displayPages.push(i);
          }
          // console.log(this.displayPages)
        }
      }

      // this.displayPages.push(this.pages)

      // console.log('display pages', this.displayPages)
    },
    checkCat(albumObj, cid, pIndex) {
      var photo = albumObj.photos[pIndex];
      var tags = photo.tags;
      if (tags.includes(cid)) {
        return true;
      } else {
        return false;
      }
    },
    async selectCat(albumObj, cid, pIndex, event) {
      // console.log('album', albumObj)
      // console.log('cid', cid)
      // console.log('pIndex', pIndex)
      // console.log(event)
      var paramObj = {
        albumId: albumObj._id,
        catId: cid,
        pIndex: pIndex,
        add: event
      };

      const { data } = await ListingsRepository.tagAlbumPhoto(paramObj);

      console.log("data", data);
      // if (event){
      //   console.log('add category')
      // } else {
      //   console.log('remove category')
      // }
    },
    async fetchPhotosByTag(slug, page = 1, limit) {
      // console.log('in fetch album')
      const { data } = await ListingsRepository.getPhotosByTag(
        slug,
        page,
        limit
      );
      if (data.success) {
        this.photos = data.data;
        this.photos.sort((a, b) => 0.5 - Math.random());
        this.pages = data.pages;
        this.displaySubPages();
      } else {
        this.photos = {};
        // this.album['name'] = "Oops! Photos not found matching that tag"
      }

      // console.log(this.category)
    },
    async fetchAlbumCategory(slug) {
      // console.log('in fetch album')
      const { data } = await ListingsRepository.getAlbumCategory(slug);
      if (data.success) {
        this.category = data.data;
      } else {
        this.category = {};
        // this.album['name'] = "Oops! Photos not found matching that tag"
      }

      // console.log(this.category)
    },
    async fetchAlbumCategories() {
      const { data } = await ListingsRepository.getAlbumByCategories();
      if (data.success) {
        this.albumCategories = data.data;
        console.log(this.albumCategories);
      }
    },
    viewPhoto(photoObj) {
      // set up photoObj
      this.setViewObj({ photo: photoObj });
      console.log(photoObj);
      this.showModal({
        title: "",
        component: "PhotoModal",
        footer: false,
        hideLogo: true
      });
    },
    ...mapActions([
      "addBookmark",
      "setMessageVars",
      "showModal",
      "useSMS",
      "setViewObj"
    ])
  },
  computed: {
    ...mapState(["imagePath", "categories", "user"])
  },
  mounted() {
    // if (!this.categories){
    //   this.fetch()
    // }
    this.fetchPhotosByTag(this.slug, this.currentPage, this.limit);
    this.fetchAlbumCategory(this.slug);
    // this.fetchAlbumCategories()
  }
};
</script>
<style scoped>
.page-header {
  text-align: center;
}

.photogallery {
  margin-top: 25px;
}

.photo {
  margin-bottom: 20px;
  xbox-shadow: 3px 3px 5px #ccc;
}

/*.btn{
    margin:0 5px;
    border-width: 0px
  }*/

.btn-request {
  border-width: 1px;
}

button.btn-request:hover {
  background: #ea208f;
  color: #fff;
}

.photo img {
  max-width: 100%;
  cursor: pointer;
  xheight: 100%;
}
</style>
